angular.module('core').filter('statusLabel', [
    function() {

        function getLabel (status) {

            var labels = {
                'Completed All Available': 'label label-congratulate',
                'Goal Reached': 'label label-congratulate',
                'Goal Not Reached': 'label label-notify',
                'Assignment Stopped': 'label label-warning',
                'default': ''
            };
            return (labels[status] || labels['default']);
        }

        return getLabel;
    }
]);

